import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { IoMenu } from "react-icons/io5";
import logo from "../../assets/logo.png";
import { navLinks } from "../../data/navLinks";
import Icon from "../ui/Icon";
import Button from "../ui/Button";
import MobileMenu from "./MobileMenu";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
    <header className="fixed top-0 left-0 z-50 w-full border-b-2 border-primary nav-glass shadow-md">
      <nav className="mx-auto flex h-24 max-w-container-max items-center justify-between px-margin-mobile md:px-gutter">
        {/* Logo — oversized badge that hangs below the bar without changing its height */}
        <Link
          to="/"
          aria-label="Cargo Power Logistics — home"
          className="relative flex h-24 items-start"
        >
          <div className="nav-glass mt-2 flex items-center justify-center rounded-2xl border border-outline-variant/40 p-3 shadow-xl transition-transform duration-200 hover:scale-105 md:mt-3 md:rounded-3xl md:p-4">
            <img
              src={logo}
              alt="Cargo Power Logistics"
              className="h-20 w-auto object-contain md:h-28"
              loading="eager"
            />
          </div>
        </Link>

        {/* Desktop links */}
        <div className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) =>
            link.children ? (
              <div key={link.label} className="group relative">
                <NavLink
                  to={link.to}
                  className={({ isActive }) =>
                    `nav-link flex items-center gap-1 pb-1 ${isActive ? "active" : ""}`
                  }
                >
                  {link.label}
                  <Icon name="expand_more" className="text-[16px]" />
                </NavLink>
                <ul className="invisible absolute left-1/2 top-full z-50 mt-2 min-w-[220px] -translate-x-1/2 rounded-xl border border-outline-variant/40 bg-surface-container-lowest p-2 opacity-0 shadow-lg transition-all duration-300 group-hover:visible group-hover:opacity-100">
                  {link.children.map((child) => (
                    <li key={child.to}>
                      <NavLink
                        to={child.to}
                        className={({ isActive }) =>
                          `block rounded-lg px-4 py-2.5 font-body-md text-body-md transition-colors hover:bg-surface-container-low ${
                            isActive ? "text-primary" : "text-on-surface-variant"
                          }`
                        }
                      >
                        {child.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <NavLink
                key={link.label}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `nav-link pb-1 ${isActive ? "active" : ""}`
                }
              >
                {link.label}
              </NavLink>
            )
          )}
        </div>

        {/* Right actions */}
        <div className="flex items-center gap-3">
          <Button to="/contact" className="hidden md:inline-flex">
            Request Quote
          </Button>
          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="relative z-10 flex h-11 w-11 items-center justify-center rounded-lg border border-outline-variant/50 bg-primary-container text-white shadow-md lg:hidden"
            aria-label="Open menu"
          >
            <IoMenu className="text-2xl" />
          </button>
        </div>
      </nav>
    </header>

    {/* Rendered outside the header so its fixed positioning is relative to the
        viewport (the header's backdrop-filter would otherwise clip it). */}
    <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
};

export default Navbar;
